import React from "react";
import { Route, Routes } from "react-router-dom";

import Apps from "./Apps";
import Funds from "./Funds";
import Holdings from "./Holdings";

import Orders from "./Orders";
import Positions from "./Positions";
import Summary from "./Summary";
import WatchList from "./WatchList";
import { GeneralContextProvider } from "./GeneralContext";

import { FinnhubProvider } from "../data/FinnhubContext";

const HomeDashboard = () => {
  return (
    <div className="dashboard-container">
      <FinnhubProvider>
        <GeneralContextProvider>
          <WatchList />
        </GeneralContextProvider>

        <div className="content">
          <Routes>
            <Route exact path="/" element={<Summary />} />
            <Route path="/orders" element={<Orders />} />
            <Route path="/holdings" element={<Holdings />} />
            <Route path="/positions" element={<Positions />} />
            <Route path="/funds" element={<Funds />} />
            <Route path="/charts" element={<Apps />} />
          </Routes>
        </div>
      </FinnhubProvider>
    </div>
  );
};


export default HomeDashboard;
